// css文件中不要使用import
import sns, {fb, twitter, google, line} from './sns/index';
import token from './token';

const cache = UpSDK.cache;

class Auth {

    constructor(cfg) {
        cfg = cfg || {};
        this.code = Uplib.url.query('code');
        this.platform = Uplib.native.getPlatform();
        this.oauthtype = cfg.oauthtype || 'fb';
    }

    init() {

        Uplib.loading.show();

        let oauthPlatform = this.getOAuthPlatform();

        UpSDK.config.oauthtype = oauthPlatform;

        switch (oauthPlatform) {
            case 'wechat':
                this.wechat();
                break;
            case 'twitter':
                this.twitter();
                break;
            case 'weibo':
                this.weibo();
                break;
            case 'qq':
                this.qq();
                break;
            case 'google':
                this.google();
                break;
            case 'line':
                this.line();
                break;
            case 'facebook':
            default:
                this.facebook();
        }
    }

    getOAuthPlatform() {
        // switch (this.platform) {
        //     case 'wechat':
        //     case 'twitter':
        //     case 'weibo':
        //     case 'facebook':
        //         result = this.platform;
        //         break;
        //     default:
        // switch (this.oauthtype) {
        //     case 'twitter':
        //     case 'weibo':
        //     case 'google':
        //     case 'wechat':
        //     case 'qq':
        //         result = this.oauthtype;
        //         break;
        //     case 'fb':
        //     default:
        //         if (domain == 'h5.upliveapp.com' || domain == 'uplive.appanda.cn') {
        //             result = 'qq';
        //         } else {
        //             result = 'facebook';
        //         }
        // }

        // }

        // return result;

        if (this.oauthtype === 'fb') {
            return 'facebook';
        }
        return this.oauthtype;
    }

    wechat() {
        if (!this.code) {
            sns.jumpToSNS('wechat');
        } else {
            if (cache.getCache('isBackFromSNS')) {
                cache.removeCache('isBackFromSNS');
                token.get('wechat', this.code);
            } else {
                sns.jumpToSNS('wechat');
            }
        }
    }

    twitter() {

        let oauth_token = Uplib.url.query('oauth_token');
        // 当获取request_token成功后, 则继续跳转到twitter的oauth验证页面获取verifier
        $.channel.on('getTwitterOauthTokenSuccess', (resp) => {
            if (!resp || !resp.token) {
                Uplib.notification.simple('get oauth_token fail');
                return;
            }
            sns.twitterJumpForCode(resp.token);
            cache.setCache('twitter', resp);
        });

        // 当url中不包含oauth_token时
        // 用户首次进入此授权登录页面, 先从java端获取request_token
        if (!oauth_token) {
            twitter.getRequestToken();
        } else {
            // 反之, 已从twitter oauth页面返回并携带oauth_token
            // 此时可获取up usertoken
            if (cache.getCache('isBackFromSNS')) {
                cache.removeCache('isBackFromSNS');
                token.get('twitter', oauth_token, cache.getCache('twitter').tokenSecret, Uplib.url.query('oauth_verifier'));
            } else {
                twitter.getRequestToken();
            }
        }
    }

    weibo() {
        if (!this.code) {
            sns.weiboJumpForCode();
        } else {
            if (cache.getCache('isBackFromSNS')) {
                cache.removeCache('isBackFromSNS');
                token.get('weibo', this.code);
            } else {
                sns.weiboJumpForCode();
            }
        }
    }

    qq() {
        if (!this.code) {
            sns.qqJumpForCode();
        } else {
            if (cache.getCache('isBackFromSNS')) {
                cache.removeCache('isBackFromSNS');
                token.get('qq', this.code);
            } else {
                sns.qqJumpForCode();
            }
        }
    }

    line() {
        const code = this.code;
        if (!code) {
            sns.lineJumpForCode();
        } else {
            if (cache.getCache('isBackFromSNS')) {
                cache.removeCache('isBackFromSNS');
                //  现需要调用获取Token，有点像google的登录
                const code = Uplib.url.query('code');
                const state = Uplib.url.query('state');
                // 此处需要注册用户
                token.get('line', code, state);
            } else {
                sns.lineJumpForCode();
            }
        }
    }

    facebook() {
        //  说明已经登录过了
        if (window.FBOauthResponse) {
            token.get('facebook', window.FBOauthResponse.accessToken);
        } else {
            if (typeof window.FB !== 'undefined') {
                // 自己调用登录
                FB.login(() => {
                    checkLoginState();
                    if (window.FBOauthResponse) {
                        token.get('facebook', window.FBOauthResponse.accessToken);
                    }
                });
            }
        }
    }

    google() {

        $.channel.on('authSuccess', (data) => {
            $.channel.off('authSuccess');
            let user = {
                uid: data.uid,
                userToken: data.userToken,
                subscribe: data.subscribe,
                username: data.username,
                avatar: data.avatar,
                countryCode: data.countryCode,
                gender: data.gender,
                grade: data.grade,
                upliveCode: data.upliveCode
            };

            UpSDK.writeLoginInfo(user);

            if (!data.countryCode) {
                token.setProfile(user);
            } else {
                UpSDK.emit('getUserSuccess', user);
            }
        });

        google.init();
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/index.js